
  document.addEventListener('DOMContentLoaded', function() {
    // Function to update the cart total
    function updateCartTotal() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartTotal = cart.total_price;
          const formattedTotal = Shopify.formatMoney(cartTotal, "{{ shop.currency }}");
          console.log("formattedTotalformattedTotal", formattedTotal);
          document.getElementById('cart-total-price').textContent = formattedTotal;
        });
    }

    // Initial update on page load
    // updateCartTotal();

    // Update cart total whenever the cart is updated
    document.addEventListener('cart:updated', updateCartTotal);
  });
document.addEventListener("DOMContentLoaded", function() {
  // Get all li elements with the class mega-menu
  var megaMenus = document.querySelectorAll("li .mega-menu");

  // Check if there are at least 3 elements
  if (megaMenus.length >= 3) {
    // Add the sticky class to the second and third elements
    megaMenus[1].classList.add("sticky-mega-menu");
    megaMenus[2].classList.add("sticky-mega-menu");
  }
});


function moveDown(elem) {
  var parentElem = elem.parentElement;
  var elemIndex = Array.prototype.indexOf.call(parentElem.children, elem);
  parentElem.insertBefore(elem, parentElem.children[elemIndex + 2]);
}
  document.addEventListener("DOMContentLoaded", (event) => {
    // Fix double-click issue for canvas print links
    const canvasPrintLinks = document.querySelectorAll('.product__canvas-print--link');

    canvasPrintLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        // Prevent multiple clicks and ensure immediate navigation
        if (this.href && !e.defaultPrevented) {
          e.preventDefault();
          window.location.href = this.href;
        }
      });
    });

    //  set poster print filter text to art print
    let count = 0;
    let interval = setInterval(function () {
      count++;
      document.querySelectorAll(".boost-sd__filter-option-item-label").forEach((elem) => {
        if (elem.innerText.toString().toLowerCase() == "poster print") {
          elem.innerText = "Art Print";
        } else if (count > 1000) {
          clearInterval(interval);
        }
      });
    }, 10);

    let optionsCount = 0;
    let conditionsMet = 0;
    let optionsInterval = setInterval(function () {
      //console.log("setInternval "+ count);
      optionsCount++;
      document.querySelectorAll(".boost-sd__filter-option-item-label").forEach((elem) => {
        //console.log("asdfasdf");
        if (elem.innerText == "HORIZONTAL") {
          conditionsMet++;
          elem.innerText = "Horizontal";
        } else if (elem.innerText == "SQUARE") {
          conditionsMet++;
          elem.innerText = "Square";
        } else if (elem.innerText == "VERTICAL") {
          conditionsMet++;
          elem.innerText = "Vertical";
        }
        if (conditionsMet == 3) {
          // clearInterval(optionsInterval);
        }
      });
      if (optionsCount > 2000) {
        //console.log("setInternval > 1500 capitalize");
        clearInterval(optionsInterval);
      }

    }, 20);





    setTimeout(function name(params) {
      document.querySelectorAll(".boost-sd__format-currency").forEach((elem) => {
        if(elem.classList.contains("boost-sd__product-price--compare")){
          moveDown(elem.previousElementSibling);
        }else{

        elem.innerText = "From " + elem.innerText;

        }
      });




      // set correct percentage off label
      // document.querySelectorAll(".boost-sd__product-label--sale").forEach((e)=> {
      //   e.outerHTML = "<div class='hc-sale-tag'><span>20%</span></div>"
      // });


    }, 1800);



    // setTimeout((f)=>{
    //         // remove from from compare at price
    //   document.querySelectorAll(".boost-sd__format-currency--price-compare").forEach((elem) => {
    //     //debugger;
    //    document.querySelectorAll(".boost-sd__format-currency--price-compare");
    //   });

    // },4000)


    window.navigation.addEventListener("navigate", (event) => {
      console.log('location changed!');


      setTimeout(function name(params) {
        document.querySelectorAll(".boost-sd__format-currency").forEach((elem) => {
          if(elem.classList.contains("boost-sd__product-price--compare")){
                      moveDown(elem.previousElementSibling);

          }else{
          if (!elem.innerText.toString().includes("From")) {
            elem.innerText = "From " + elem.innerText;
          }
          }

        });

      // set correct percentage off label
      // document.querySelectorAll(".boost-sd__product-label--sale").forEach((e)=> {
      //   e.outerHTML = "<div class='hc-sale-tag'><span>20%</span></div>"
      // });

      }, 1800);


      setTimeout(function name(params) {
        document.querySelectorAll(".boost-sd__filter-option-item-label").forEach((elem) => {
          console.log(elem.innerText);
          if (elem.innerText == "HORIZONTAL" || elem.innerText == "Horizontal") {
            console.log("hor true");
            elem.innerText = "Horizontal";
          } else if (elem.innerText == "SQUARE" || elem.innerText == "Square") {
            console.log("sq true");
            elem.innerText = "Square";
          } else if (elem.innerText == "VERTICAL" || elem.innerText == "Vertical") {
            console.log("ver true");
            elem.innerText = "Vertical";
          } else if (elem.innerText.toString().toLowerCase() == "poster print") {
            elem.innerText = "Art Print";
          }
        });
      }, 1400);

document.querySelectorAll(".boost-sd__format-currency").forEach((elem) => {
   if(elem.parentElement.firstElementChild.classList.contains("boost-sd__product-price--compare")){

   }else{
     if(elem.parentElement.parentElement.firstElementChild.classList.contains("boost-sd__product-price--compare")){

     }else{
       moveDown(elem.parentElement);
     }

   }
});


    });


    document.addEventListener("scroll", (event) => {
      setTimeout(function name(params) {
        document.querySelectorAll(".boost-sd__format-currency").forEach((elem) => {
          // debugger;
          if(elem.classList.contains("boost-sd__product-price--compare")){
           // debugger;
                    //  moveDown(elem.previousElementSibling);

          }else {
          if (!elem.innerText.toString().includes("From")) {
            elem.innerText = "From " + elem.innerText;
          }
          }


        });

        // set correct percentage off label
        // document.querySelectorAll(".boost-sd__product-label--sale").forEach((e)=> {
        //   e.outerHTML = "<div class='hc-sale-tag'><span>20%</span></div>"
        // });

document.querySelectorAll(".boost-sd__format-currency").forEach((elem) => {
   if(elem.parentElement.firstElementChild.classList.contains("boost-sd__product-price--compare")){

   }else{
     if(elem.parentElement.parentElement.firstElementChild.classList.contains("boost-sd__product-price--compare")){

     }else{
       moveDown(elem.parentElement);
     }

   }
});

      }, 1800);


    });

  });
document.addEventListener('DOMContentLoaded', function() {
    function addFromTextToPrices() {
        // Select all elements with the class 'boost-sd__format-currency'
        var priceElements = document.querySelectorAll('.boost-sd__format-currency');

        // Loop through each price element and prepend "From: "
        priceElements.forEach(function(priceElement) {
            // Check if "From:" is already added to avoid duplication
            if (!priceElement.innerHTML.startsWith('From: ')) {
                priceElement.innerHTML = 'From: ' + priceElement.innerHTML;
            }
        });
    }

    // Initial run to add "From:" to existing elements
   // addFromTextToPrices();

    // Create a MutationObserver to monitor the DOM for changes
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // Check if new nodes are added or existing nodes are modified
            if (mutation.addedNodes.length || mutation.type === 'childList') {
               // addFromTextToPrices();
            }
        });
    });

    // Start observing the document body for changes in child elements and subtree
    observer.observe(document.body, { childList: true, subtree: true });

document.querySelectorAll( '[ class*="homepage_id" ]' ).forEach((e)=>{
    if(!e.innerText.includes("From")){
        e.innerText = "From "+e.innerText;
    }
})


});


